module.exports = __webpack_public_path__ + "static/media/S1_00009.2fa91faf.jpg";